/**
 * Когда весь js отработал и страница построилась,
 * показываем её
 */

setTimeout(() => {
    document.getElementsByTagName('html')[0].classList.add('_is-preloaded');

    // Зажигаем событие
    const event = new CustomEvent('preloaded');
    window.dispatchEvent(event);
}, 500);



// WEBPACK FOOTER //
// ./_src/js/Preloader.js